export const showAddPrivacyModal = () => {
    return {
      type: "SHOW_ADD_PRIVACY_MODAL",
    };
  };
  
  export const hideAddPrivacyModal = () => {
    return {
      type: "HIDE_ADD_PRIVACY_MODAL",
    };
  };
  